import {Section} from "./Actions";
import {Action} from "react-fetching-library";
import {ServicesUrl} from "./paths";
import {NewsSection} from "./NewsAction";

export interface PopupsData {
    id: number,
    title: string,
    external: string,
    intetnal: string,
    image: string,
    date: string
}

export interface PopupsSection extends Section {
    popups: PopupsData[];
    isClosed: boolean;
}

export const getPopupData  = (version: string) : Action<PopupsSection> => ({
    method: 'GET',
    endpoint: `${ ServicesUrl.popups }?v=${ version }`,
    body: undefined,
});